function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

import React, { useContext } from "react";
import { Box, Button, ResponsiveContext, Text } from "grommet";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { PasswordInput } from "../../Inputs/PasswordInput";
import { Controller, useForm } from "react-hook-form";
import { makeValidationSchema } from "./makeValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
export var PasswordForm = function PasswordForm(_ref) {
  var passwordMessage = _ref.passwordMessage,
    setNewPassword = _ref.setNewPassword,
    passwordError = _ref.passwordError;
  var validateForm = makeValidationSchema();

  var _useForm = useForm({
      resolver: yupResolver(validateForm),
      shouldFocusError: false,
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    errors = _useForm.formState.errors,
    clearErrors = _useForm.clearErrors,
    setValue = _useForm.setValue;

  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);

  var onSubmit = function onSubmit(data) {
    return setNewPassword(data);
  };

  return /*#__PURE__*/ React.createElement(
    "form",
    {
      onSubmit: handleSubmit(onSubmit),
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        style: {
          borderRadius: "10px",
          backgroundColor: "#F8F8F8",
        },
        pad: "2rem",
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: "column",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: isMobileWidth ? "column" : "row",
            gap: "2rem",
            justify: "between",
          },
          /*#__PURE__*/ React.createElement(Controller, {
            name: "password",
            control: control,
            render: function render(_ref2) {
              var _errors$password;

              var field = _ref2.field;
              return /*#__PURE__*/ React.createElement(
                PasswordInput,
                _extends({}, field, {
                  error:
                    (_errors$password = errors.password) == null
                      ? void 0
                      : _errors$password.message,
                  onFocus: function onFocus() {
                    return clearErrors("password");
                  },
                  name: "settings-current-password",
                  id: "current-password",
                  label:
                    "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0442\u0430\u0440\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
                  placeholder: "Your current password",
                  onChange: function onChange(e) {
                    return setValue(e.target.value);
                  },
                })
              );
            },
          }),
          /*#__PURE__*/ React.createElement(Controller, {
            name: "new_password",
            control: control,
            render: function render(_ref3) {
              var _errors$new_password;

              var field = _ref3.field;
              return /*#__PURE__*/ React.createElement(
                PasswordInput,
                _extends({}, field, {
                  error:
                    (_errors$new_password = errors.new_password) == null
                      ? void 0
                      : _errors$new_password.message,
                  onFocus: function onFocus() {
                    return clearErrors("new_password");
                  },
                  name: "settings-new-password",
                  id: "new-password",
                  label:
                    "\u041F\u0440\u0438\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
                  placeholder: "Your new password",
                  onChange: function onChange(e) {
                    return setValue(e.target.value);
                  },
                })
              );
            },
          })
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            direction: isMobileWidth ? "column" : "row",
            gap: "2rem",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              align: "center",
              height: "56px",
              width: {
                max: "397.3px",
              },
              margin: {
                top: "2rem",
              },
              pad: {
                vertical: "1rem",
              },
              style: {
                borderRadius: "5px",
                backgroundColor: "black",
                color: "#F8F8F8",
                cursor: "pointer",
              },
            },
            /*#__PURE__*/ React.createElement(
              Button,
              {
                type: "submit",
              },
              "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"
            )
          ),
          passwordMessage
            ? /*#__PURE__*/ React.createElement(
                Box,
                {
                  pad: {
                    top: "2rem",
                  },
                },
                /*#__PURE__*/ React.createElement(
                  Text,
                  {
                    size: "small",
                    color: "grey",
                  },
                  "\u041F\u0430\u0440\u043E\u043B\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D"
                )
              )
            : null,
          passwordError
            ? /*#__PURE__*/ React.createElement(
                Box,
                {
                  pad: {
                    top: "2rem",
                  },
                },
                /*#__PURE__*/ React.createElement(
                  Text,
                  {
                    size: "small",
                    color: "red",
                  },
                  passwordError
                )
              )
            : null
        )
      )
    )
  );
};
